import { css } from "@emotion/react";

import { black, greySecondary } from "../../styles/variables";

export const select = css`
  border-radius: 4px;
  width: 100%;
  height: 40px;
  color: ${black};
  padding: 6px 8px;

  svg {
    color: ${black};
  }

  .MuiSelect-select:focus {
    background-color: unset;
  }

  &.MuiInput-underline::before {
    display: none;
  }

  &.MuiInput-underline::after {
    display: none;
  }

  &.Mui-focused {
    border: solid 1px ${black};
  }

  &:hover {
    background: ${greySecondary};
  }
`;

export const menu = css`
  .MuiMenu-paper {
    margin-top: 8px;

    /* workaround for design */
    width: 207px;
  }

  .MuiSelect-select {
    font-weight: bold;
  }

  .MuiListItem-root.Mui-selected {
    font-weight: bold;
    background-color: unset;
  }
`;
